module.exports = __webpack_public_path__ + "static/media/coreValues-03.d989a7e8.svg";